import { IconDefinition } from "@fortawesome/free-solid-svg-icons";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface SidemenuItem {
  title: string;
  icon: IconDefinition;
  href: string;
  /** Stable end-to-end test selector supplied by the owning micro-frontend. */
  dataQa?: string;
  /** Extra paths that should also count as "active" for this item, besides `href`. */
  activeMatch?: string[];
  /**
   * A path that's shared by multiple sidebar items (e.g. a generic detail
   * route reused by several list pages), where the URL alone can't say which
   * item owns it. The item only counts as active on this path if the given
   * key/value also matches `location.state`, set via `navigate(path, { state })`
   * when entering that route.
   */
  activeMatchState?: { path: string; key: string; value: string };
}

const initialState: SidemenuItem[] = [];

export const sidemenuSlice = createSlice({
  name: "sidemenu",
  initialState: initialState,
  reducers: {
    updateMenuItems: (_state: any, action: PayloadAction<SidemenuItem[]>) => {
      return action.payload;
    },
  },
});

export const { updateMenuItems } = sidemenuSlice.actions;

export default sidemenuSlice.reducer;
